import { useQuery } from 'react-query';
import { useCurrentUserCtx } from 'client/contexts/CurrentUser';
import { AnchorAPI } from '../../modules/AnchorAPI';

export const FETCH_EPISODE_OVERVIEW = 'episodeOverview';
function useFetchEpisodeOverview({ webEpisodeId }: { webEpisodeId?: string }) {
  const {
    state: { userId },
  } = useCurrentUserCtx();

  const { data, status, refetch } = useQuery(
    [FETCH_EPISODE_OVERVIEW, webEpisodeId],
    () => AnchorAPI.fetchEpisodeOverview({ webEpisodeId: webEpisodeId! }),
    {
      enabled: !!webEpisodeId && !!userId,
    }
  );

  return { episodeOverviewData: data, status, refetch };
}

export { useFetchEpisodeOverview };
